module.exports = __webpack_public_path__ + "img/postgresql-stencil.409e270d.svg";